import { defineAsyncComponent } from 'vue';

export default {
	description: "Позиции накладных-требований",
	access: {
		read: true,
		create: true,
		update: true,
		delete: true
	},
	forms: {
		edit: {
			component: defineAsyncComponent(() => import('./forms/Edit.vue')),
			panel: {
				width: '70%',
				modal: true
			}
		}
	}
};

